import React, { useMemo } from 'react';
import Sidebar from '../../components/Sidebar';
import ListaDocenti from './listaDocenti';
import { useAuth } from '../../contexts/Auth';
import { isDelegato } from '../../libs/utils/auth';

const Docenti = () => {
  const [{ profile }] = useAuth();
  const SIDEBAR_ITEMS = useMemo(() => {
    if (isDelegato(profile)) {
      return [
        { href: '/utenti', label: 'Tutti gli utenti' },
        { href: '/docenti', label: 'Docenti' },
        { href: '/utenti/anzianita', label: 'Anzianità' },
      ];
    }
    return [
      { href: '/utenti', label: 'Tutti gli utenti' },
      { href: '/docenti', label: 'Docenti' },
      { href: '/utenti/nuovo', label: 'Nuovo utente' },
      { href: '/utenti/anzianita', label: 'Anzianità' },
    ];
  }, [profile]);

  return (
    <div className='grid w-full grid-cols-12 gap-8 px-4 pb-10 pt-7 lg:py-12 lg:px-10'>
      <Sidebar items={SIDEBAR_ITEMS} />

      <div className='col-span-12 lg:col-span-9 xl:col-span-10'>
        <ListaDocenti />
      </div>
    </div>
  );
};

export default Docenti;
